<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container"
                :style="{ width: displayPatientForm ? '50%' : '30%', height: '45em', display: 'flex', flexDirection: 'column' }">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">{{ $resident({ capitalize: true }) }} Search </h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body" style="flex-grow: 1; max-height: 80%; overflow-y: auto; overflow-x: hidden;">
                    <slot name="body">
                        <form v-on:submit.prevent class="action-modal">
                            <div class="drug-register-table table-container"
                                style="padding-top: 5em; width: fit-content; box-shadow: none; margin: 0 auto"
                                v-if='!$store.state.user.role.permissions.includes("can_view_resident")'>
                                <h4
                                    style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; height: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">
                                    You do not have permission to access this feature. Please talk to your admin if you
                                    require access.</h4>
                                </div>
                            <!-- BASIC INFO -->
                            <div v-else class="form-section-container"
                                style="grid-template-columns: 1fr; margin: 0; margin-right: 20px; width: auto; grid-template-rows: 1fr 10fr;">
                                <div style="display: flex; align-items: center;">
                                    <div v-if="!displayPatientForm" style="width: 40%;">
                                        <input v-on:keyup.enter="searchResident" v-model="searchTerm" :placeholder="'Enter ' + $resident({ capitalize: true }) + ' name or Medicare Number'"
                                            style="position: relative; width:100%" />
                                    </div>

                                    <p v-if="!displayPatientForm" class="submit-button blue-button"
                                        style="margin-left: 10px; margin-right: 10px;"
                                        @click="() => { if (searchTerm) { searchForPatient(searchTerm) } }">Search</p>
                                    <div v-if="!displayPatientForm" style="margin-left: 5px;">
                                        <Checkbox inputId="binary" v-model="includeInactive" :binary="true" />
                                        <label for="binary" style="margin-left: 10px;">Include inactive {{ $resident({ plural: true }) }}</label>
                                    </div>
                                    <p v-if="!displayPatientForm && $store.state.user.role.permissions.includes('can_do_resident')"
                                        class=" blue-button"
                                        style="margin: 0; padding: 5px; margin-left: 15px; font-weight: bold;"
                                        @click="() => { displayPatientForm = true; displayResults = false; searchResults = '' }">+ Add New
                                        {{ $resident({ capitalize: true }) }}</p>

                                </div>

                                <div
                                    v-if="displayPatientForm && $store.state.user.role.permissions.includes('can_do_resident')">
                                    <div style="display: grid; grid-gap: 10px;">
                                        <h4 style="text-align: left; margin-bottom: 0px;">Create {{ $resident({ capitalize: true }) }}</h4>
                                        <PatientCoreFields
                                            compact
                                            hideHeadings
                                            :showPreferredName="false"
                                            :showDvaDetails="false"
                                            :showIhi="false"
                                            :personalInformation="personalInformation"
                                            :regulatoryNumbers="regulatory_numbers"
                                            :facilities="facilities"
                                            :nodes="nodes"
                                            :selectedFacility="selectedFacility"
                                            :selectedNodeKey="selectedNodeKey"
                                            @update:personalInformation="personalInformation = $event"
                                            @update:regulatoryNumbers="regulatory_numbers = $event"
                                            @update:selectedFacility="selectedFacility = $event"
                                            @update:selectedNodeKey="selectedNodeKey = $event"
                                            :loadingLocations="loadingLocations"
                                            :isSimplified="isSimplified"
                                            @facility-change="retrieveSelectedFacilityLocations()" />
                                        <p v-if="createUserError" style="color: red; font-weight: 500; font-size: 1em;">
                                            {{ createUserError }}</p>
                                        <div style="display: flex; justify-content: flex-end; margin-top: 1em;">
                                            <p class="error-button" style="margin: 0; padding: 5px; border-radius: 6px; font-weight: bold; width: 15em;  margin-right: 10px; cursor: pointer;"
                                            @click="() => { displayPatientForm = false; clearPatientForm() }">Cancel New
                                            {{ $resident({ capitalize: true }) }}</p>
                                            <p @click="requiredDetails && !creatingPatient && submitPatient()"
                                                :class="requiredDetails && !creatingPatient ? 'blue-button' : 'grey-button'"
                                                style="cursor:pointer; width: 15em; padding: 5px; border-radius: 6px; font-weight: bold; margin: 0;">Create {{ $resident({ capitalize: true }) }}
                                            </p>

                                        </div>

                                    </div>
                                </div>
                                <div v-if="loadingPatients">
                                    <i class="pi pi-spin pi-spinner"
                                        style="font-size: 2rem !important;margin-top: 2em;"></i>
                                </div>
                                <p v-if="searchError" style="color: red; font-weight: 500; font-size: 1em;">
                                    {{ searchError }}</p>
                                <div v-if="!loadingPatients">
                                    <h4 style="text-align: left; margin: 0; margin-top: 10px;" v-if="searchResults">
                                        Search Results</h4>
                                    <!-- SEARCH RESULTS -->
                                    <div class="patient-search-results-container" v-if="searchResults">

                                        <div class="individual-patient-container" v-for="(item, index) in searchResults"
                                            :key="index" @click="selectPatient(item)" style="position: relative;">
                                            <div v-if="item.personal_information?.similar_sounding_name" class="similar-name-tag-top">⚠️ Similar Sounding Name</div>
                                            <p>
                                                <img style="margin-left: 20px;" onerror="this.onerror=null; this.className='resident-image-default resident-image smaller'" class="resident-image smaller" v-if="item.image_information && item.image_information.url" :src="item.image_information.url" />
                                                <img style="margin-left: 20px;" v-else class="resident-image-default resident-image smaller" >
                                            </p>
                                            <div class="patient-result-info">
                                                <p v-if="item.personal_information"><b>Name:</b>
                                                    {{ item.personal_information.first_name }}
                                                    {{ item.personal_information.last_name }}</p>
                                                <p
                                                    v-if="item.regulatory_information && item.regulatory_information.length">
                                                    <b>Medicare Number:</b> {{
                                                            item.regulatory_information[0].data.slice(0, 4)
                                                    }}
                                                    {{ item.regulatory_information[0].data.slice(4, 9) }}
                                                    {{ item.regulatory_information[0].data.slice(9) }}</p>
                                                <p><b>DOB:</b> {{ item.personal_information &&
                                                        item.personal_information.dob ? item.personal_information.dob : ''
                                                }}
                                                </p>
                                                <p><b>Location:</b> {{ item.physical_location &&
                                                        item.physical_location.location ?
                                                        item.physical_location.location.name : ''
                                                }}</p>
                                            </div>
                                        </div>
                                        <div v-if="!searchResults.length">
                                            <h4>No results found.</h4>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </form>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end;">
                    <slot name="footer" style="display: flex;" v-if="!displayPatientForm">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel</p>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import PatientCoreFields from '@/components/patientViewComponents/PatientCoreFields.vue';
import {
    buildRegulatoryPayload,
    emptyRegulatoryNumbers,
    extractLocationUuid,
    formatDobForSubmit,
    hasRequiredPatientDetails,
    isSimplifiedOnboarding,
} from '@/services/patientValidation';

export default {
    props: ['close', 'patient'],
    components: {
        PatientCoreFields
    },
    data() {
        return {
            facilities: [],
            selectedFacility: null,
            locationDirectory: '',
            searchError: '',
            searchTerm: '',
            includeInactive:false,
            loadingPatients: false,
            loadingLocations: false,
            creatingPatient: false,
            createUserError: '',
            selectedNodeKey: null,
            mappedLocs: '',

            nodes: [],
            displayResults: false,
            displayPatientForm: false,
            personalInformation: {
                first_name: '',
                last_name: '',
                dob: '',
                preferred_name: '',
                tag: [],
                sex: '',
            },
            selectedLocation: '',
            regulatory_numbers: emptyRegulatoryNumbers(),
            searchResults: ''
        }
    },
    computed: {
        isSimplified() {
            return isSimplifiedOnboarding(this.$store);
        },
        requiredDetails() {
            return hasRequiredPatientDetails({
                personalInformation: this.personalInformation,
                regulatoryNumbers: this.regulatory_numbers,
                hasLocation: !!this.selectedNodeKey,
                isSimplified: this.isSimplified,
            });
        }
    },
    methods: {
        searchResident(){
            this.searchForPatient(this.searchTerm);

        },
        retrieveSelectedFacilityLocations() {
            this.loadingLocations = true;
            this.locationDirectory = '';
            this.selectedNodeKey = null;
            this.nodes = [];
            if (!this.selectedFacility || !this.selectedFacility.value) {
                this.loadingLocations = false;
                return;
            }
            axios.post(`/facility/${this.selectedFacility.value}/locations`, {}, this.$store.state.header).then(res => {
                this.$store.dispatch('getRefreshToken');
                this.nodes = Array.isArray(res.data) ? res.data : [];
                this.nodes.forEach(node => {
                    node.label = node.name;
                    if (node.children && node.children.length) {
                        this.getChildLocation(node);
                    }
                })
                this.loadingLocations = false;
            }).catch(err => {
                console.log('Error retrieving facility locations:', err);
                this.loadingLocations = false;
            })
        },
        getFacilities() {
            axios.post('/get-facilities', {}, this.$store.state.header).then(res => {
                this.facilities = Array.isArray(res.data) ? res.data : [];
            }).catch(err => {
                console.log('err issss', typeof err.response.data);
                if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                    console.log('yes, it does include expired')
                    this.$router.push('/login');
                }
                console.log('err is', err.response.data, err.response.data);
            })
        },
        closeModal() {
            console.log('hitting this closemodal function');
            if (this.reloadPageOnClose == true) {
                this.$emit('close', 'reload');
            } else {
                this.$emit('close', true);
            }
        },
        getChildLocation(location) {
            location.label = location.name;
            if (location.children && location.children.length) {
                location.children.forEach(child => {
                    this.getChildLocation(child);
                })
            }
        },
        searchForPatient(term) {
            this.searchError = '';
            this.displayResults = true;
            this.loadingPatients = true;
            axios.post('/search-patients',
                { page: 1, name: this.searchTerm, location: this.$store.state.currentLocation.uuid, include_inactive: this.includeInactive },
                this.$store.state.header
            ).then(res => {
                console.log('these are the search results', res);
                this.$store.dispatch('getRefreshToken');
                this.searchResults = res.data.patients;
                this.loadingPatients = false;
            }).catch(err => {
                console.log('this is the search error', err.response);
                this.searchError = err.response.data;
                this.loadingPatients = false;
            })
            console.log('this is the search term', term);
        },
        selectPatient(patient) {
            this.$emit('patient', patient);
            console.log('this is the patient selected', patient);
        },
        submitPatient() {
            this.createUserError = '';
            if (!this.requiredDetails) {
                this.createUserError = "All required fields must be filled in to create a " + this.$resident() + ".";
                return;
            }
            this.creatingPatient = true;

            const personalPayload = { ...this.personalInformation };
            if (personalPayload.dob) {
                personalPayload.dob = formatDobForSubmit(personalPayload.dob);
            }
            const regulatory_numbers = buildRegulatoryPayload(this.regulatory_numbers);
            const locationUuid = extractLocationUuid(this.selectedNodeKey);

            axios.post('/person/bundle', personalPayload, this.$store.state.header).then(res => {
                this.$store.dispatch('getRefreshToken');
                const uuid = res.data.uuid;

                const regulatoryRequest = regulatory_numbers.length
                    ? axios.post(`/person/${uuid}/regulatory`, { regulatory_numbers: regulatory_numbers }, this.$store.state.header)
                    : Promise.resolve();

                // 'active' rather than the full create flow's 'onboarding': a resident added
                // mid-workflow is usable straight away. The row itself is not optional though -
                // patient search drops anyone with no status row at all, and the administration
                // search only returns status 'active'.
                const statusRequest = axios.post(`/person/${uuid}/status`, { status: 'active' }, this.$store.state.header);

                return Promise.all([statusRequest, regulatoryRequest]).then(() =>
                    axios.post(`/person/${uuid}/location`, { status: 'resident', location: locationUuid }, this.$store.state.header)
                ).then(res2 => {
                    this.$emit('patient', {
                        uuid: uuid,
                        physical_location: {
                            location: res2.data.location
                        },
                        personal_information: {
                            first_name: this.personalInformation.first_name,
                            last_name: this.personalInformation.last_name,
                            dob: personalPayload.dob
                        },
                        regulatory_information: regulatory_numbers
                    })
                    this.closeModal();
                })
            }).catch(err => {
                this.creatingPatient = false;
                console.log('this is the create patient error', err, err.response);
                this.createUserError = err.response && err.response.data
                    ? err.response.data
                    : 'Failed to create ' + this.$resident() + '.';
            })
        },
        clearPatientForm() {
            this.personalInformation = {
                first_name: '',
                last_name: '',
                dob: '',
                preferred_name: '',
                tag: [],
                sex: '',
            }
            this.regulatory_numbers = emptyRegulatoryNumbers();
            this.selectedFacility = null;
            this.selectedNodeKey = null;
            this.nodes = [];
            this.createUserError = '';
            this.creatingPatient = false;
        }
    },
    mounted() {
        this.getFacilities();
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";








.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}



.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}

.individual-patient-container {
    display: flex;
    align-items: center;
    background-color: #f1f1f1;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius:12px;
}

.patient-result-info {
    p {
        font-size: 0.95em;
        margin: 10px;
    }

    text-align: left;
    padding-left: 25px !important;
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.similar-name-tag-top {
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: #ff9800;
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.7rem;
    font-weight: bold;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    border: 2px solid white;
}
</style>
